var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentsPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.49958C15.5 9.4325 13.9325 11 11.9996 11C10.0668 10.9998 8.5 9.43241 8.5 7.49958C8.50015 5.56688 10.0669 4.00015 11.9996 4C13.9324 4 15.4998 5.56679 15.5 7.49958Z",
    fill: "#FFCA9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77734 19.4349C5.77734 19.8264 6.09473 20.1438 6.48624 20.1438H17.5139C17.9053 20.1436 18.2228 19.8263 18.2228 19.4349V17.8593C18.2227 16.8358 17.8157 15.8545 17.092 15.1307C16.3682 14.4069 15.3862 14 14.3626 14H9.6366C8.61309 14.0001 7.63181 14.407 6.90808 15.1307C6.18434 15.8545 5.77743 16.8357 5.77734 17.8593V19.4349Z",
    fill: "#FFCA9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9745_33156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0835 19.5V17.833C17.0834 17.1481 16.811 16.4912 16.3267 16.0068C15.8422 15.5224 15.1847 15.25 14.4995 15.25H9.49951C8.81449 15.2501 8.15773 15.5224 7.67334 16.0068C7.18895 16.4912 6.91659 17.148 6.9165 17.833V19.5C6.9165 19.9142 6.58072 20.25 6.1665 20.25C5.75229 20.25 5.4165 19.9142 5.4165 19.5V17.833C5.41659 16.7502 5.8471 15.712 6.61279 14.9463C7.37849 14.1806 8.41666 13.7501 9.49951 13.75H14.4995C15.5825 13.75 16.6214 14.1805 17.3872 14.9463C18.1528 15.712 18.5834 16.7502 18.5835 17.833V19.5C18.5835 19.9141 18.2476 20.2498 17.8335 20.25C17.4193 20.25 17.0835 19.9142 17.0835 19.5Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 7.83301C14.5833 6.40642 13.4261 5.25 11.9995 5.25C10.573 5.25018 9.41668 6.40653 9.4165 7.83301C9.4165 9.25963 10.5729 10.4168 11.9995 10.417C13.4262 10.417 14.5835 9.25974 14.5835 7.83301ZM16.0835 7.83301C16.0835 10.0882 14.2547 11.917 11.9995 11.917C9.7445 11.9168 7.9165 10.0881 7.9165 7.83301C7.91668 5.5781 9.74461 3.75018 11.9995 3.75C14.2546 3.75 16.0833 5.57799 16.0835 7.83301Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9745_33156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsPageIcon);
export default __webpack_public_path__ + "static/media/students-page-icon.94608dd8e56fa940c9cae6a3118234d9.svg";
export { ForwardRef as ReactComponent };